import { DeleteIcon } from "@/constants/utils/svgs";
import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { FaPlus } from "react-icons/fa6";
import { MdOutlineChangeCircle } from "react-icons/md";
const Dropzone = ({
  image,
  removeImage,
  onDrop,
  disabled = false,
  classname,
  imgLoad,
  imgStyle,
  isReplace = false,
}: any) => {
  const handleDrop = useCallback(
    (e: any) => {
      e.preventDefault();
      const files = [...e.dataTransfer.files];
      onDrop(files);
    },
    [onDrop]
  );

  const handleDragOver = useCallback((e: any) => {
    e.preventDefault();
  }, []);
  // const handleInputChange = useCallback((e: any) => {
  //   const files = [...e.target.files];
  //   onDrop(files);
  // }, [onDrop]);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return (
    <div onDrop={handleDrop} onDragOver={handleDragOver}>
      <div className="pb-2">
        {!image ? (
          <div
            className={`bg-slate-100   cursor-pointer  flex justify-center items-center flex-col
            focus:ring-1 focus:ring-primary-red
            ${
              classname
                ? classname
                : imgStyle
                ? imgStyle
                : "w-32 h-32 rounded-lg py-8 mr-2"
            }`}
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            {imgLoad ? (
              <p className="text-gray-400 text-center ">Uploading...</p>
            ) : (
              <div>
              <FaPlus className="text-gray-400 text-2xl" />
              </div>
            )}
          </div>
        ) : isReplace ? (
          <div className="flex flex-col items-center">
            <img
              src={image}
              alt="Uploaded File"
              className={`object-cover focus:ring-1 focus:ring-primary-red ${
                classname
                  ? "w-24 h-16 rounded-full"
                  : imgStyle
                  ? imgStyle
                  : "w-32 h-32 mr-2 rounded-lg"
              }`}
            />
            {!disabled && (
              <div
                {...getRootProps({
                  className: "cursor-pointer mt-1 p-1 bg-p-gray rounded-full",
                })}
              >
                 <input {...getInputProps()} />
                <MdOutlineChangeCircle className="text-primary-red text-xl" />
              </div>
            )}
          </div>
        ) : (
          <div className="flex flex-col items-center">
            <img
              src={image}
              alt="Uploaded File"
              className={`object-cover focus:ring-1 focus:ring-primary-red ${
                classname
                  ? "w-24 h-16 rounded-full"
                  : imgStyle
                  ? imgStyle
                  : "w-32 h-32 mr-2 rounded-lg"
              }`}
            />
            {!disabled && (
              <div
                onClick={removeImage}
                className="cursor-pointer mt-1 p-1 bg-p-gray rounded-full"
              >
                <DeleteIcon />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropzone;
